import { CallingTheme, darkTheme } from "@azure/communication-react";
import { PartialTheme } from "@fluentui/react";

export const chatTeamsDarkTheme: PartialTheme & CallingTheme = {
    ...darkTheme,
    palette: {
        ...darkTheme.palette,
        themeLight: "#2b2b40",
    }
};
